export default __webpack_public_path__ + "static/media/Button-WStore.7869aa20.svg";